exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".conditions-header[data-v-04d8caf3]{font-size:1.5rem;position:relative;top:18px}\n", ""]);

